<div class="min-h-full" style="background-color: #fafaf7;">

  <!-- Loading -->
  @if (isLoading()) {
    <div class="flex items-center justify-center min-h-[60vh]">
      <div class="flex flex-col items-center gap-5">
        <div class="relative w-12 h-12">
          <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
          <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
        </div>
        <p class="text-stone-600 font-medium text-sm">Chargement...</p>
      </div>
    </div>
  }

  @if (!isLoading()) {
    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 py-8 space-y-6">

      <!-- Error -->
      @if (errorMessage()) {
        <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
          <svg class="w-4 h-4 flex-shrink-0 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"/>
          </svg>
          {{ errorMessage() }}
        </div>
      }

      <!-- Table card -->
      <div class="bg-white rounded-3xl shadow-sm border border-stone-100 overflow-hidden">

        <!-- Search + filter bar -->
        <div class="px-6 py-4 border-b border-stone-100 flex items-center gap-3 flex-wrap">

          <!-- Search -->
          <div class="relative flex-1 min-w-0 max-w-sm">
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
            </svg>
            @if (isFiltering()) {
              <div class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 border-2 border-stone-300 border-t-primary-400 rounded-full animate-spin"></div>
            }
            <input
              type="search"
              class="w-full bg-white border border-stone-200 text-stone-800 placeholder-stone-400 text-sm rounded-lg pl-11 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              placeholder="Rechercher un réseau social..."
              (input)="onSearch($any($event.target).value)"
            />
          </div>

          <!-- Status filter -->
          <select
            class="border border-stone-200 text-stone-700 text-sm rounded-lg pl-3 pr-8 py-2 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all bg-white flex-shrink-0"
            [value]="selectedStatus()"
            (change)="onStatusFilter($any($event.target).value)">
            <option value="">Tous les statuts</option>
            <option value="ACTI">En ligne</option>
            <option value="INAC">Hors ligne</option>
          </select>

          <!-- Add button -->
          @if (permService.can('marketing', 'reseaux_sociaux', 'create')) {
            <button
              (click)="onAddNew()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors text-xs font-medium flex-shrink-0 ml-auto">
              <span class="material-icons text-base">add</span>
              Nouveau réseau social
            </button>
          }
        </div>

        <!-- Table -->
        <div class="overflow-x-auto">
          <table class="w-full text-sm" role="table">
            <thead>
              <tr class="border-b border-stone-100 bg-stone-50">
                <th class="px-3 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[48px]">ID</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider">Plateforme</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider">URL</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[80px]">Ordre</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[112px]">Statut</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-stone-500 uppercase tracking-wider w-[100px]">Actions</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-stone-50">

              @if (items().length === 0) {
                <tr>
                  <td colspan="6" class="px-6 py-16 text-center">
                    <div class="flex flex-col items-center gap-3">
                      <div class="w-14 h-14 rounded-3xl bg-stone-100 flex items-center justify-center">
                        <span class="material-icons text-stone-300 text-2xl">share</span>
                      </div>
                      <p class="text-stone-500 text-sm font-medium">Aucun réseau social trouvé</p>
                      <p class="text-stone-400 text-xs">Ajoutez vos réseaux sociaux en cliquant sur "Nouveau réseau social"</p>
                    </div>
                  </td>
                </tr>
              }

              @for (item of items(); track item.social_media_id) {
                <tr class="hover:bg-stone-50 transition-colors duration-150"
                  [class.opacity-60]="item.social_media_status === 'INAC'">

                  <!-- ID -->
                  <td class="px-3 py-3 w-[48px]">
                    <span class="text-xs font-mono text-stone-400">#{{ item.social_media_id }}</span>
                  </td>

                  <!-- Plateforme -->
                  <td class="px-4 py-3">
                    <p class="font-semibold text-stone-800 text-xs">{{ item.social_media_platform }}</p>
                  </td>

                  <!-- URL -->
                  <td class="px-4 py-3">
                    <a [href]="item.social_media_url" target="_blank" rel="noopener noreferrer"
                      class="text-xs text-primary-600 hover:text-primary-700 underline truncate max-w-[300px] block"
                      (click)="$event.stopPropagation()">
                      {{ item.social_media_url }}
                    </a>
                  </td>

                  <!-- Ordre -->
                  <td class="px-4 py-3 w-[80px]">
                    <span class="text-xs text-stone-500 font-mono">{{ item.social_media_order }}</span>
                  </td>

                  <!-- Statut -->
                  <td class="px-4 py-3 w-[112px]">
                    <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border whitespace-nowrap"
                      [class]="statusBadgeClass(item.social_media_status)">
                      <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
                        [class]="item.social_media_status === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
                      {{ statusLabel(item.social_media_status) }}
                    </span>
                  </td>

                  <!-- Actions -->
                  <td class="px-4 py-3 w-[100px]">
                    <div class="flex items-center gap-1">
                      @if (permService.can('marketing', 'reseaux_sociaux', 'edit')) {
                        <button (click)="onEdit(item.social_media_id); $event.stopPropagation()"
                          class="w-7 h-7 rounded-lg flex items-center justify-center text-stone-400 hover:text-primary-600 hover:bg-primary-50 transition-colors"
                          title="Modifier">
                          <span class="material-icons text-base">edit</span>
                        </button>
                      }
                      @if (permService.can('marketing', 'reseaux_sociaux', 'status')) {
                        <button (click)="onToggleStatus(item, $event)"
                          class="w-7 h-7 rounded-lg flex items-center justify-center text-stone-400 hover:text-amber-600 hover:bg-amber-50 transition-colors"
                          [title]="item.social_media_status === 'ACTI' ? 'Mettre hors ligne' : 'Mettre en ligne'">
                          <span class="material-icons text-base">{{ item.social_media_status === 'ACTI' ? 'visibility_off' : 'visibility' }}</span>
                        </button>
                      }
                      @if (permService.can('marketing', 'reseaux_sociaux', 'delete')) {
                        <button (click)="onDelete(item, $event)"
                          class="w-7 h-7 rounded-lg flex items-center justify-center text-stone-400 hover:text-red-600 hover:bg-red-50 transition-colors"
                          title="Supprimer">
                          <span class="material-icons text-base">delete</span>
                        </button>
                      }
                    </div>
                  </td>

                </tr>
              }

            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      @if (pagination().totalPages > 1) {
        <div class="flex items-center justify-between">
          <p class="text-xs text-stone-400">
            Page <span class="font-semibold text-stone-600">{{ pagination().page }}</span> sur
            <span class="font-semibold text-stone-600">{{ pagination().totalPages }}</span>
            · <span class="font-semibold text-stone-600">{{ pagination().total }}</span> réseaux sociaux
          </p>
          <div class="flex items-center gap-1">
            <button type="button"
              (click)="onPageChange(pagination().page - 1)"
              [disabled]="pagination().page === 1"
              class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-500 hover:bg-stone-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
            </button>

            @for (p of pageNumbers(); track p) {
              @if (p === '...') {
                <span class="w-8 h-8 flex items-center justify-center text-xs text-stone-400">...</span>
              } @else {
                <button type="button"
                  (click)="onPageChange($any(p))"
                  class="w-8 h-8 rounded-xl text-xs font-medium transition-colors"
                  [class]="$any(p) === pagination().page
                    ? 'bg-primary-600 text-white shadow-sm'
                    : 'text-stone-500 hover:bg-stone-100'">
                  {{ p }}
                </button>
              }
            }

            <button type="button"
              (click)="onPageChange(pagination().page + 1)"
              [disabled]="pagination().page === pagination().totalPages"
              class="w-8 h-8 rounded-xl flex items-center justify-center text-stone-500 hover:bg-stone-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </button>
          </div>
        </div>
      }

    </div>
  }

  <!-- Status confirmation modal -->
  @if (pendingStatus()) {
    <div class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div class="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full space-y-4">
        <h3 class="text-base font-semibold text-stone-800">
          {{ pendingStatus()!.newStatus === 'ACTI' ? 'Publier le réseau social' : 'Désactiver le réseau social' }}
        </h3>
        <p class="text-sm text-stone-600">
          {{ pendingStatus()!.newStatus === 'ACTI'
            ? 'Ce réseau social sera visible sur le site public.'
            : 'Ce réseau social sera masqué du site public.' }}
        </p>
        <div class="flex items-center justify-end gap-3">
          <button (click)="cancelStatus()"
            class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
            Annuler
          </button>
          <button (click)="applyStatus()"
            class="px-4 py-2 text-sm font-medium text-white rounded-xl transition-colors"
            [class]="pendingStatus()!.newStatus === 'ACTI' ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-amber-500 hover:bg-amber-600'">
            {{ pendingStatus()!.newStatus === 'ACTI' ? 'Publier' : 'Désactiver' }}
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Delete confirmation modal -->
  @if (pendingDelete()) {
    <div class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div class="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full space-y-4">
        <h3 class="text-base font-semibold text-stone-800">Supprimer le réseau social</h3>
        <p class="text-sm text-stone-600">
          Voulez-vous supprimer <span class="font-medium">{{ pendingDelete()!.social_media_platform }}</span> ? Cette action est irréversible.
        </p>
        <div class="flex items-center justify-end gap-3">
          <button (click)="cancelDelete()"
            class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
            Annuler
          </button>
          <button (click)="applyDelete()"
            class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-xl transition-colors">
            Supprimer
          </button>
        </div>
      </div>
    </div>
  }

</div>
